import {
  COMPARISON_ACTIVE_PANEL_URL_VALUES,
  MAX_COMPARISON_SLIDER_POSITION,
  MIN_COMPARISON_SLIDER_POSITION,
  type PrivateAssetComparisonQueryPatch,
  type PrivateAssetComparisonURLState,
} from '~/constants/assetComparison';
import { QueryParamNames } from '~/constants/search';

const clampSliderPosition = (position: number) =>
  Math.min(Math.max(position, MIN_COMPARISON_SLIDER_POSITION), MAX_COMPARISON_SLIDER_POSITION);

/** Serializes only the private asset-comparison URL fields supplied by the caller. */
export const getPrivateAssetComparisonQuery = ({
  activePanel,
  comparisonClipId,
  isLinked,
  mode,
  sliderPosition,
}: Partial<PrivateAssetComparisonURLState>): PrivateAssetComparisonQueryPatch => ({
  ...(activePanel === undefined
    ? {}
    : { [QueryParamNames.comparisonActivePanel]: COMPARISON_ACTIVE_PANEL_URL_VALUES[activePanel] }),
  ...(comparisonClipId === undefined ? {} : { [QueryParamNames.comparisonClipId]: comparisonClipId }),
  ...(isLinked === undefined ? {} : { [QueryParamNames.comparisonLinked]: String(isLinked) }),
  ...(mode === undefined ? {} : { [QueryParamNames.comparisonMode]: mode }),
  ...(sliderPosition === undefined
    ? {}
    : { [QueryParamNames.comparisonSliderPosition]: String(clampSliderPosition(sliderPosition)) }),
});
